import type { AccountantStatusInvoicesDetailEntity } from "../entities/AccountantStatusEntity";
import type {
  AccountantStatusPaginatedMonthParams,
  AccountantStatusRepository,
} from "../repositories/AccountantStatusRepository";

export class GetAccountantStatusMonthDetailInvoicesUseCase {
  constructor(private readonly repository: AccountantStatusRepository) {}

  async execute(
    params: AccountantStatusPaginatedMonthParams,
  ): Promise<AccountantStatusInvoicesDetailEntity> {
    return this.repository.getMonthDetailInvoices(params);
  }
}
